export default "__VITE_ASSET__ad20a8c0__"